import { useGetTreinseriesForToday } from "@/entities/treinserie";
import { Maatregel } from "@/entities/vsm";
import { useCallback } from "react";

/**
 * Returns a lookup that tells whether the treinserie(s) of a maatregel occur in the dagplan of today.
 *
 * Returns `undefined` while the dagplan is not (yet) available, so callers can skip showing a warning
 * instead of falsely reporting a missing treinserie.
 */
export function useIsMaatregelInDagplan(): (maatregel: Maatregel) => boolean | undefined {
    const { data: treinseries } = useGetTreinseriesForToday();

    return useCallback(
        (maatregel: Maatregel) => {
            if (!treinseries) {
                return undefined;
            }
            const treinseriesToCheck =
                maatregel.type === "RijdtGroep" ? maatregel.maatregelen.map((m) => m.treinserie) : [maatregel.treinserie];
            return treinseriesToCheck.every((serie) => treinseries.includes(serie));
        },
        [treinseries]
    );
}
